import { useMutation } from '@tanstack/react-query';
import productUpdateExcelUseCase from '../factories/productUpdateExcel';

export const useUploadFiles = () => {
  return useMutation(productUpdateExcelUseCase.uploadFiles);
};
